/* eslint-disable import/prefer-default-export */
import db from '@/firebase';

const generateUnbookCode = () => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;

  for (let i = 0; i < 5; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const fetchGifts = () => new Promise((resolve, reject) => {
  db.collection('gifts')
    .get().then((data) => {
      const gifts = [];

      data.docs.forEach((doc) => {
        const {
          name,
          description,
          link,
          image_280x232: image280x232,
          image_300xauto: image300xauto,
          booked,
          bookersEmail,
          unbookCode,
        } = doc.data();

        gifts.push({
          id: doc.id,
          name,
          description,
          link,
          image280x232,
          image300xauto,
          booked,
          bookersEmail,
          unbookCode,
        });
      });
      resolve(gifts);
    })
    .catch((error) => reject(error));
});

export const fetchGift = (id) => new Promise((resolve, reject) => {
  db.collection('gifts')
    .doc(id)
    .get()
    .then((gift) => {
      const {
        name,
        description,
        link,
        image_280x232: image280x232,
        image_300xauto: image300xauto,
        booked,
        bookersEmail,
        unbookCode,
      } = gift.data();

      resolve({
        id: gift.id,
        name,
        description,
        link,
        image280x232,
        image300xauto,
        booked,
        bookersEmail,
        unbookCode,
      });
    })
    .catch((error) => reject(error));
});

export const bookGift = (id, bookersEmail = '') => new Promise((resolve, reject) => {
  const unbookCode = generateUnbookCode();

  db.collection('gifts').doc(id).update({ booked: true, bookersEmail, unbookCode })
    .then(() => resolve(unbookCode))
    .catch((error) => reject(error));
});

export const unbookGift = (id) => new Promise((resolve, reject) => {
  db.collection('gifts').doc(id).update({ booked: false, bookersEmail: '', unbookCode: '' })
    .then(() => resolve())
    .catch((error) => reject(error));
});

export const sendEmail = ({
  to,
  subject,
  text,
  html,
} = {}) => new Promise((resolve, reject) => {
  db.collection('mail').add({
    to,
    message: {
      subject,
      text,
      html,
    },
  })
    .then((doc) => {
      const unsubscribe = db.collection('mail').doc(doc.id)
        .onSnapshot((snapshot) => {
          const { delivery: { state = '' } = {} } = snapshot.data();

          if (state && (state === 'ERROR' || state === 'FAILURE')) {
            db.collection('mail').doc(doc.id).update({ delivery: { state: 'RETRY' } });
          } else if (state && state === 'SUCCESS') {
            unsubscribe();
          }
        });
      resolve();
    })
    .catch((error) => reject(error));
});

export const reportError = (error) => db.collection('errors').add({
  date: new Date().toISOString(),
  error,
});
